module.exports = __webpack_public_path__ + "img/mainmenbuttonLL.5c35cdf3.png";